import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=79cca0ac&scoped=true&"
import script from "./CheckBox.vue?vue&type=script&lang=ts&"
export * from "./CheckBox.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=79cca0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cca0ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
